define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action/GroupController",
	"csi/config",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare, csi, _, GroupController, config, locale, MessageDialog, xml) {

	const LOCK_HOST_PLACEMENTS_FOR_SOURCES = "LockHostPlacementsForSources";

	return declare(GroupController, {
		/**
		 * Figure out if subtype has option "LockThemePlacementList", then make sure there are no linked-to-theme placements
		 * Checks if BOM's parent is a Product Source and if subtype has option "LockHostPlacementsForSources",
		 * then make sure there are no linked-to-style placements
		 * @return {boolean}
		 */
		canDeleteSection() {
			const {m_cache, qrGroup} = this;
			const bomRevNode = this.getParent();
			const bomNode = m_cache.get(bomRevNode.__Parent__);
			const lockThemePlacementList = bomNode && config.getNodeSetting(bomNode, "LockThemePlacementList");
			const lockHostPlacementsForSources = bomNode && config.getNodeSetting(bomNode, "LockHostPlacementsForSources");
			let blocked;
			if (lockThemePlacementList) {
				const {groupValue} = qrGroup;
				const items = m_cache.getNodes(bomRevNode.Items);
				blocked = items.some((item) => (item.DSSection === groupValue) && xml.isValidURL(item.FromMaterialPlanPlacement));
				return !blocked;
			} else if (this.isSourceBOM(bomNode) && lockHostPlacementsForSources) {
				blocked = this.sectionHasLinkedPlacements(bomRevNode);
				return !blocked;
			}

			return true;
		},

		/**
		 * Checks if it's a Product Source BOM
		 * @return {boolean}
		 */
		isSourceBOM(bomNode) {
			const bomParent = this.m_cache.get(bomNode.__Parent__);
			if (bomParent == null) {
				return false;
			}
			return bomParent?.$Type === "ProductSource";
		},

		/**
		 * @override
		 * Return name of group
		 */
		getStringParameters() {
			return [this.qrGroup.getGroupName()];
		},

		/**
		 * @override
		 * Return true if can delete the section
		 */
		hasToConfirmAction() {
			return this.canDeleteSection();
		},

		/**
		 * Write operation to delete BOMSection
		 */
		toWriterRequest() {
			var qr = this.qrGroup;
			var groupValue = qr.getGroupValue();
			var req = this.inherited(arguments).addParameter("ParentURL", xml.ATTR_REF, qr.parentUrl);

			if (groupValue == xml.VALUE_BLANK) {
				req.addParameter("AddURLs", xml.ATTR_REFLIST, [csi.EMPTY_URL]);
			} else {
				// figure out which section has the name
				var cache = this.m_cache;

				var parentNode = cache.getNode(qr.parentUrl);
				var sectionURLToDelete = _.find(parentNode.AllSections, function(sectionURL) {
					return locale.getNodeName(cache.getNode(sectionURL)) == groupValue;
				});

				if (sectionURLToDelete)
					req.addParameter("AddURLs", xml.ATTR_REFLIST, [sectionURLToDelete]);
			}

			return req;
		},

		/**
		 * Checks if there are any linked placements in the section
		 * Also accounts for "blank" section
		 * @param {Node} section
		 * @return {boolean}
		 */
		sectionHasLinkedPlacements(revision) {
			const ctx = this.getContext();
			const section = ctx.getNode();
			const items = ctx.cache.getNodes(revision.Items);
			// Blank section comes up as undefined, we still want to prevent it from
			// getting deleted if it has linked placements
			const sectionURL = section ? section.$URL : csi.EMPTY_URL;
			return items.some((item) => (item.DSSection === sectionURL) && item.LinkedDSLineItemSysID !== "");
		},

		/**
		 * Prompt confirmation with buttons “Unlink” and “Cancel”.
		 * @override
		 *
		 */
		confirmAction(params) {
			const ctx = this.getContext();
			const bom = ctx.cache.getNode(ctx.getParent().__Parent__);

			const sectionName = ctx.getNode()?.$Name || locale.resource(xml.VALUE_BLANK);

			if (bom.$Type != null && bom.$Type === "ApparelBOM" && bom.ThemeBOMLinkedStyleBOMs.length > 0) {
				params.message = locale.resource("BomSectionDeleteLinked_Confirm", [sectionName]);
				this.m_action.confirmAction = MessageDialog.BUTTON_UNLINK_AND_DELETE;

			} else {
				params.message = locale.resource("BomSectionDelete_Confirm", [sectionName]);
				this.m_action.confirmAction = MessageDialog.BUTTON_DELETE;
			}
			this.inherited(arguments);
		},

		/**
		 * @override
		 * If section cannot be deleted, then show error dialog
		 */
		preProcess() {
			if (!this.canDeleteSection()) {
				const {m_cache} = this;
				const bomRevNode = this.getParent();
				const bomNode = m_cache.get(bomRevNode.__Parent__);
				if (this.isSourceBOM(bomNode)) {
					this.displayErrorDialog({suffix: "_LockHostPlacementsForSources"});
				} else {
					this.displayErrorDialog({suffix: "_LockedSection"});
				}
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Delete section (group) from table
		 */
		postProcessSuccess() {
			this.widget.deleteRow(this.refNode);
		}
	});
});
